import styled from "styled-components";
import forumIcon from "./img/forum.png"
import editIcon from "./img/edit.png"
import nearMeIcon from "./img/near_me.png"
import personPinIcon from "./img/person_pin.png"
import importContacsIcon from "./img/import_contacts.png"
import fileDownloadIcon from "./img/file_download.png"
import dashBoardIcon from "./img/home.png"
import { useContext } from "react";
import Home from "../ContentArea/Home/Home";
import Guias from "../ContentArea/Guias/Guias";
import { PageContext } from "../Context/PageContext";
import Cadastro from "../ContentArea/Cadastro/Cadastro";
import NewAccountDescript from "../ContentArea/Cadastro/CadastroDescript/NewAccountDescript";
import Database from "../ContentArea/Database/Database";
import Rankings from "../ContentArea/Ranking/Rankings";
import Downloads from "../ContentArea/Download/Download";


function NavBar() {

    const { setPage, setRegisterPageSection, dashBoardInitialPage } = useContext(PageContext);


    return(
        <NavContainer>
            <Ul>
                <Li onClick={() => setPage(<Home />)}><IconImg img={forumIcon}/>HOME</Li>
                <Li onClick={() =>{
                    setPage(<Cadastro/>);
                    setRegisterPageSection(<NewAccountDescript/>)
                    }}><IconImg img={editIcon}/>CADASTRO</Li>
                <Li onClick={() => setPage(<Guias/>)}><IconImg img={nearMeIcon} />GUIAS</Li>
                <Li onClick={() => setPage(<Rankings/>)}><IconImg img={personPinIcon} />RANKINGS</Li>
                <Li onClick={() => setPage(<Database/>)}><IconImg img={importContacsIcon} />DATABASE</Li>
                <Li onClick={() => setPage(<Downloads/>)}><IconImg img={fileDownloadIcon} />DOWNLOAD</Li>
                <Li onClick={() => setPage(<>{dashBoardInitialPage}</>)}><IconImg img={dashBoardIcon} />CONTA</Li>
            </Ul>
        </NavContainer>
    );
};


const NavContainer = styled.nav`
    margin: 0 0 20px 0;
    padding: 0;
    //border: solid 2px black;
    self: start;
    z-index: 10;

`;

const MobileMenuLine = styled.div`
    background-color: rgba(156, 5, 5, 1);
    width: 100vw;
    height: 50px;
    position: fixed;
    text-align: center;
    top: 0;
    left: 0;

    &:hover {
    background-color: rgba(156, 5, 5, 1);
    }
`

const TitleMBar = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24pt;
    font-weight: bold;
`

const Ul = styled.ul`
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-evenly;
    list-style-type: none;

    @media(max-width: 1000px) {
    //flex-direction: column;
    align-items: center;
    }

`;

const Li = styled.li`
    display: flex;
    align-items: center;
    background-color: rgb(156, 5, 5);
    font-size: 14px;
    color: white;
    padding: 7px 18px;
    margin: 0 2px;
    border-radius: 2px;
    letter-spacing: 0.02rem;
    box-shadow: 0px .5px 0px black;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

     &:hover {
        filter: contrast(500%);
        transition: .3s;
        scale: 1.0;
        
     }
    &:not(:hover) {
        background-color: rgb(144, 7, 7);
        transition: .3s;
     }

    @media(max-width: 1000px) {
    //width: 80vw;
    font-size: 9px;
    width: 18px;
    margin: 5px 2px;
    justify-content: center;
    }

`;

const LiBlocked = styled.li`
    display: flex;
    align-items: center;
    background-color: rgb(156, 5, 5);
    font-size: 14px;
    color: white;
    padding: 7px 18px;
    margin: 0 2px;
    border-radius: 2px;
    letter-spacing: 0.02rem;
    box-shadow: 0px .5px 0px black;
    cursor: url('cursors0007.png'), pointer;
    pointer-events: none;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

     &:hover {
        filter: contrast(500%);
        transition: .3s;
        scale: 1.0;
        
     }
    &:not(:hover) {
        background-color: rgb(144, 7, 7);
        transition: .3s;
     }

    @media(max-width: 1000px) {
    //width: 80vw;
    font-size: 9px;
    width: 18px;
    margin: 5px 2px;
    justify-content: center;
    }

`;

const IconImg = styled.div `
    background-image: url('${props => props.img}');
    background-size: cover;
    width: 20px;
    height: 22px;
    margin-right: 13px;

    @media(max-width: 1000px) {
    background-image: url(' ');
    margin-right: 0px;
    }
    
`;

export default NavBar;